import { useConfig } from "@jti/app-context/useConfig";
import { SticksProductDetailsContainer as UiSticksProductDetailsContainer } from "@jti/product-details/sticks-product-details";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import type { SticksProductDetailsContainerProps } from "./SticksProductDetailsContainer.inputs.builder";

export function SticksProductDetailsContainer(props: SticksProductDetailsContainerProps) {
  const { DISABLE_COMMERCE, enableSubscriptions, defaultProductCtaLabel, defaultProductCtaUrl } = useConfig();
  const { __ } = useTranslations();

  return (
    <UiSticksProductDetailsContainer
      {...{
        sku: props.sku ?? "",
        badgeText: __("product.badge.new"),
        overwriteBadgeText: props.overwriteBadgeText ?? "",
        description: props.description ?? "",
        shortDescription: props.shortDescription ?? "",
        knowMoreUrl: props.knowMoreUrl ?? "",
        multiPackDescription: props.multiPackDescription ?? "",
        productCta: {
          label: props.productCta?.label || defaultProductCtaLabel || "",
          url: props.productCta?.url || defaultProductCtaUrl || "",
        },
        productName: props.productName ?? "",
        hasBadge: props.hasBadge ?? false,
        hasDiscountBadge: props.hasDiscountBadge ?? false,
        hasStrikethroughPrice: props.hasStrikethroughPrice ?? false,
        hideCta: props.hideCta ?? false,
        isCommerceDisabled: !!DISABLE_COMMERCE,
        isMultiPackEnabled: props.isMultiPackEnabled ?? false,
        hidePrice: props.hidePrice ?? false,
        multiPackName: props.multiPackName ?? "",
        multiPackProducts: props.multiPackProducts ?? [],
        customBuyCtaLabel: props.customBuyCtaLabel ?? "",
        sticksData: {
          single_packs: {
            onetime: props.sticksMatrixData?.single_packs.onetime ?? [],
            subscription: props.sticksMatrixData?.single_packs.subscription ?? [],
          },
          cartons: {
            onetime: props.sticksMatrixData?.cartons.onetime ?? [],
            subscription: props.sticksMatrixData?.cartons.subscription ?? [],
          },
          mix_n_match: {
            onetime: props.sticksMatrixData?.mix_n_match.onetime ?? [],
            subscription: props.sticksMatrixData?.mix_n_match.subscription ?? [],
          },
        },
        isSubscriptionsEnabled: enableSubscriptions ?? false,
      }}
    />
  );
}
